enum TranslationElements {
  RESERVATION_FEE = 'trans__fincalc__cash_breakdown__refundable_reservation_fee_label',
}

export default TranslationElements
